import { TextField } from '@mui/material'
import React from 'react'
import { local } from 'service/api'
import { useStore } from 'store'
import Menu from '../MenuV2'
import { SelectProps } from './types'

export const SelectLocal: React.FC<SelectProps> = ({
    size = 'medium',
    variant = 'filled',
    width,
    children,
}) => {
    const companyId = useStore(state => state.companyId)
    const { data } = local.useFetch({
        queryParams: { empresaId: companyId },
    })

    const locationId = useStore(state => state.locationId)
    const setLocationId = useStore(state => state.setLocationId)

    return (
        <TextField
            name="localId"
            label="Local"
            size={size}
            variant={variant}
            select
            fullWidth
            defaultValue={locationId}
            SelectProps={{
                value: locationId,
            }}
            sx={{ width }}
            onKeyDownCapture={e => e.stopPropagation()}
            onChange={e => setLocationId(Number(e.target.value))}
        >
            {children}
            {locationId === -1 && !children && (
                <Menu.Item value={-1} disabled>
                    Nenhum local
                </Menu.Item>
            )}
            {data?.map(({ nomeLocal, id }, i) => (
                <Menu.Item key={i} value={id}>
                    {nomeLocal}
                </Menu.Item>
            ))}
        </TextField>
    )
}
